export const SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS';
export const RESET_DOWNLOAD_PROGRESS = 'RESET_DOWNLOAD_PROGRESS';
export const setDownloadProgress = (dowloadId, progress, isDownloading) => {
  return {
    type: SET_DOWNLOAD_PROGRESS,
    data: { dowloadId, progress, isDownloading },
  };
};
export const resetDownloadProgress = () => {
  return {
    type: RESET_DOWNLOAD_PROGRESS,
  };
};
